import React, { ReactElement, useEffect, useState } from 'react';
import { Button } from 'antd';
import { DeleteOutlined, PaperClipOutlined } from '@ant-design/icons';
import { isEmpty } from 'lodash';

import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import { AmendmentsList } from 'pricing/components/contract/contractAmendments/ContractAmendmentsList.styles';
import { getMediaContractAmendments } from 'pricing/utilities/media/media';
import { setFileUploadedToBase64 } from 'pricing/utilities/media/setFileUploadedToBase64/setFileUploadedToBase64';
import { testId } from 'pricing/utilities/test/dataTestId';

function ContractAmendmentsList(): ReactElement | null {
  const { state, dispatch } = useContractState();
  const { amendmentFileUpload, hasAmendmentUploaded, contract } = state;
  const amendmentFiles = contract ? getMediaContractAmendments(contract.media) : [];
  const [amendmentFileUploadedPreview, setAmendmentFileUploadedPreview] = useState('');

  const handleDeleteAmendmentFileUpload = () => {
    dispatch({
      type: 'SET_AMENDMENT_FILE_UPLOAD',
      amendmentFileUpload: null,
    });
  };

  const handleAmendmentFileUploadedPreview = () => {
    window
      .open('')
      ?.document.write(
        `<iframe width='100%' height='100%' frameborder="0" border="0" cellspacing="0" src='${amendmentFileUploadedPreview}' />`,
      );
  };

  useEffect(() => {
    amendmentFileUpload &&
      setFileUploadedToBase64(amendmentFileUpload, (base64) => {
        setAmendmentFileUploadedPreview(base64 as string);
      });
  }, [amendmentFileUpload]);

  if (!amendmentFileUpload && isEmpty(amendmentFiles)) {
    return null;
  }

  return (
    <AmendmentsList>
      <h3>Amendments</h3>
      <ul>
        {amendmentFileUpload && (
          <li data-testid={testId.fileAmendmentItemUploaded}>
            <Button
              data-testid={testId.fileAmendmentItemUploadedPreviewButton}
              type="link"
              size="small"
              icon={<PaperClipOutlined />}
              onClick={handleAmendmentFileUploadedPreview}
            >
              {amendmentFileUpload.name}
            </Button>
            {!hasAmendmentUploaded && (
              <Button
                data-testid={testId.deleteAmendmentFileUpload}
                className="btn-amendment-upload-delete"
                type="link"
                size="small"
                icon={<DeleteOutlined />}
                onClick={handleDeleteAmendmentFileUpload}
              />
            )}
          </li>
        )}
        {amendmentFiles.map((file) => (
          <li key={file.id} data-testid={testId.fileAmendmentItem}>
            <Button
              data-testid={testId.fileAmendmentItemPreviewButton}
              type="link"
              size="small"
              icon={<PaperClipOutlined />}
              href={file.dataUrl}
              target="_blank"
            >
              {file.name}
            </Button>
          </li>
        ))}
      </ul>
    </AmendmentsList>
  );
}

export default ContractAmendmentsList;
